export { THEME } from './theme-default';
